import { useSyncPanelsPreferences } from "./use-sync-panels-preferences"
import { useSyncModelPreferences } from "./use-sync-model-preferences"
import { useSyncCorePreferences } from "./use-sync-core-preferences"
import { useSyncTradePreferences } from "./use-sync-trade-preferences"
import { useSyncOptimizationPreferences } from "./use-sync-optimization-preferences"

// Layout-level dashboard preference sync. Per-panel hooks
// (useSyncAssetViewPreferences, useSyncFactorsViewPreferences, useSyncKPIPreferences) must run
// inside their owning panel — they use usePanelId() and scope state per panel — so they are NOT
// aggregated here. Optimization state is dashboard-scoped, so it is.
export function useDashboardPreferencesSync(): boolean {
  const panelsLoaded = useSyncPanelsPreferences()
  const modelLoaded = useSyncModelPreferences()
  const coreLoaded = useSyncCorePreferences()
  const tradeLoaded = useSyncTradePreferences()
  const optimizationLoaded = useSyncOptimizationPreferences()

  return [panelsLoaded, modelLoaded, coreLoaded, tradeLoaded, optimizationLoaded].every(Boolean)
}
